// @ts-strict-ignore
export function initialCardsLoaded(currentDashboardId: number) {
  return (ev) =>
    ev.detail.eventName.endsWith(`Dashboard Initial Cards Fetched`) &&
    ev.detail.props.dashboardId === currentDashboardId;
}
